import HeaderAndFooter from './header-and-footer';

export default HeaderAndFooter;
